module.exports = __webpack_public_path__ + "static/img/user-bg.d763a43b.jpeg";